import { render } from "./TaskFieldForm.vue?vue&type=template&id=235fa513&scoped=true&ts=true"
import script from "./TaskFieldForm.vue?vue&type=script&lang=ts"
export * from "./TaskFieldForm.vue?vue&type=script&lang=ts"

import "./TaskFieldForm.vue?vue&type=style&index=0&id=235fa513&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235fa513"]])

export default __exports__